export default __webpack_public_path__ + "static/media/safe.827b0047.svg";